/* global window, Event */
import * as R from 'ramda';
import * as Highcharts from 'highcharts';
import angular from 'angular';

export default function ECATCategoryGraphController(
  $scope,
  $q,
  $timeout,
  brandColors
) {
  const vm = this;

  vm.render = _render;
  _initEventListeners();

  function _initEventListeners() {
    $scope.$on('reRenderCategoryGraph', ($event, args) => {
      if (args.categoryId === vm.category.categoryId) {
        _render();
      }
    });
  }


  function _render() {
    const elements = angular.element(`.ecat-category-graph[data-category-id="${vm.category.categoryId}"]`);
    const dfdRender = $q.defer();

    const xAxisLabels = [];
    const currentAssessmentScores = [];

    R.forEach((categoryFactor) => {
      xAxisLabels.push(categoryFactor.abbreviationText);
      let barColor;

      if (categoryFactor.score > 4) {
        barColor = brandColors.bankersLoveRed.$100;
      } else if (categoryFactor.score > 3) {
        barColor = brandColors.bankersLoveRed.$75;
      } else if (categoryFactor.score > 2) {
        barColor = brandColors.navantaCoral.$100;
      } else if (categoryFactor.score > 1) {
        barColor = brandColors.navantaCoral.$55;
      } else {
        barColor = brandColors.navantaCoral.$25;
      }

      const barData = {
        y: categoryFactor.score,
        color: barColor,
      };

      currentAssessmentScores.push(barData);
    },
    vm.category.categoryFactors);

    R.forEach((element) => {
      Highcharts.chart(element, {
        chart: {
          type: 'column',
        },
        plotOptions: {
          column: {
            pointPadding: 0,
            borderWidth: 0,
            pointWidth: 40,
          },
        },
        xAxis: {
          categories: xAxisLabels,
          labels: {
            y: 20,
            style: {
              fontSize: '10px',
              fontFamily: 'Nunito, sans-serif',
            },
          },
          crosshair: true,
        },
        yAxis: {
          min: 0,
          max: 5,
          title: {
            text: 'Score',
          },
        },
        title: null,
        credits: {
          enabled: false,
        },
        legend: {
          enabled: false,
        },
        series: [{
          name: 'Current Assessment',
          data: currentAssessmentScores,
        }],
        tooltip: {
          enabled: false,
        },
      });
    },
    elements);

    $timeout(() => {
      window.dispatchEvent(new Event('resize'));
    },
    50);

    dfdRender.resolve();

    return dfdRender.promise;
  }
}

ECATCategoryGraphController.$inject = [
  '$scope',
  '$q',
  '$timeout',

  'brandColors'
];
